import React from 'react';
import styled from 'styled-components';
import {ImageCompare} from '@epic-mw/react-image-compare';
import {Typography} from '../typography/Typography';
import {VerticalSpacer} from '../spacer';
import {GridContainer} from '../grid';

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    .heading,
    .paragraph {
        text-align: center;
    }
`;

export interface UeImageCompareProps {
    title?: string;
    hover?: boolean | false;
    leftImage?: string;
    rightImage?: string;
    caption?: string;
}

export const UeImageCompare = ({
    title,
    caption,
    leftImage,
    rightImage,
    ...rest
}: UeImageCompareProps): JSX.Element => {
    return (
        <GridContainer>
            <Styled>
                {title && (
                    <div>
                        <Typography variant="h2">{title}</Typography>
                        <VerticalSpacer variant="heading" />
                    </div>
                )}

                <ImageCompare leftImage={leftImage || ''} rightImage={rightImage || ''} {...rest} />

                {caption && (
                    <div>
                        <VerticalSpacer variant="eyebrow" />
                        <Typography variant="p" caption>
                            {caption}
                        </Typography>
                    </div>
                )}
            </Styled>
        </GridContainer>
    );
};
